// IndexedDB sans dépendance : trois fonctions suffisent à tout ce que l'application
// stocke, et une bibliothèque de plus serait une bibliothèque de plus à suivre.
//
// IndexedDB et non localStorage pour les données de l'utilisateur : localStorage est
// SYNCHRONE, donc il bloque le fil principal — mortel pendant qu'on fait glisser un
// jeton — et il n'a pas de transaction. Une compo de onze jetons doit s'écrire
// entièrement ou pas du tout.

const NOM = 'aja';
const VERSION = 2;
let ouverture = null;

export function base() {
  if (ouverture) return ouverture;
  ouverture = new Promise((resoudre, rejeter) => {
    const r = indexedDB.open(NOM, VERSION);
    r.onupgradeneeded = () => {
      const d = r.result;
      if (!d.objectStoreNames.contains('instantane')) d.createObjectStore('instantane');
      // Un match porte tout : adversaire, date, onze, journal, score. Les tables
      // « compos » et « journaux » de la version 1 sont laissées en place à la montée
      // de version — leur reprise se fait au premier démarrage, côté serveur, et les
      // supprimer ici perdrait ce qui n'aurait pas encore été synchronisé.
      if (!d.objectStoreNames.contains('matchs')) d.createObjectStore('matchs', { keyPath: 'id' });
      if (!d.objectStoreNames.contains('compos')) d.createObjectStore('compos', { keyPath: 'id' });
      if (!d.objectStoreNames.contains('notes')) d.createObjectStore('notes', { keyPath: 'joueurId' });
      if (!d.objectStoreNames.contains('journaux')) d.createObjectStore('journaux', { keyPath: 'matchId' });
      if (!d.objectStoreNames.contains('sortie')) d.createObjectStore('sortie', { keyPath: 'id' });
      if (!d.objectStoreNames.contains('reglages')) d.createObjectStore('reglages');
    };
    r.onsuccess = () => resoudre(r.result);
    r.onerror = () => rejeter(r.error);
  });
  return ouverture;
}

async function transaction(magasin, mode, action) {
  const d = await base();
  return new Promise((resoudre, rejeter) => {
    const t = d.transaction(magasin, mode);
    const m = t.objectStore(magasin);
    let resultat;
    try { resultat = action(m); } catch (e) { rejeter(e); return; }
    t.oncomplete = () => resoudre(resultat?.result ?? resultat);
    t.onerror = () => rejeter(t.error);
    t.onabort = () => rejeter(t.error);
  });
}

const promesse = (requete) => new Promise((ok, ko) => { requete.onsuccess = () => ok(requete.result); requete.onerror = () => ko(requete.error); });

export const lire = (magasin, cle) => transaction(magasin, 'readonly', (m) => promesse(m.get(cle)));
export const tout = (magasin) => transaction(magasin, 'readonly', (m) => promesse(m.getAll()));
export const ecrire = (magasin, valeur, cle) => transaction(magasin, 'readwrite', (m) => promesse(cle === undefined ? m.put(valeur) : m.put(valeur, cle)));
export const supprimer = (magasin, cle) => transaction(magasin, 'readwrite', (m) => promesse(m.delete(cle)));
export const vider = (magasin) => transaction(magasin, 'readwrite', (m) => promesse(m.clear()));

/** Écrire plusieurs enregistrements d'un seul coup, dans une seule transaction. */
export const ecrireLot = (magasin, valeurs) => transaction(magasin, 'readwrite', (m) => { for (const v of valeurs) m.put(v); });

/**
 * Demander au navigateur de ne pas évincer ces données.
 *
 * Safari accorde la persistance aux applications installées sans rien demander à
 * l'utilisateur. Une origine persistante échappe à l'éviction sous pression disque —
 * c'est gratuit, et ce qu'on y range (les compos, les notes) n'est nulle part ailleurs
 * tant que la file de synchronisation n'est pas partie.
 */
export async function demanderPersistance() {
  try {
    if (!navigator.storage?.persist) return null;
    if (await navigator.storage.persisted?.()) return true;
    return await navigator.storage.persist();
  } catch {
    return null;
  }
}
